// options.js
export const industries = [
    { label: "Agroindustria", value: "Agroindustria" },
    { label: "Automotriz", value: "Automotriz" },
    { label: "Construcción", value: "Construcción" },
    { label: "Consultoría", value: "Consultoría" },
    { label: "Educación", value: "Educación" },
    { label: "Energía", value: "Energía" },
    { label: "Entretenimiento", value: "Entretenimiento" },
    { label: "Finanzas", value: "Finanzas" },
    { label: "Gastronomía", value: "Gastronomía" },
    { label: "Ingeniería", value: "Ingeniería" },
    { label: "Inmobiliario", value: "Inmobiliario" },
    { label: "Logística/Transporte", value: "Logística/Transporte" },
    { label: "Manufactura", value: "Manufactura" },
    { label: "Medios", value: "Medios" },
    { label: "Minería", value: "Minería" },
    { label: "Salud", value: "Salud" },
    { label: "Seguros", value: "Seguros" },
    { label: "Servicios a Minería", value: "Servicios a Minería" },
    { label: "Servicios de Seguridad", value: "Servicios de Seguridad" },
    { label: "Servicios Públicos", value: "Servicios Públicos" },
    { label: "Tecnología", value: "Tecnología" },
    { label: "Turismo", value: "Turismo" }
];

export const periodicities = [
    { label: "Mensual", value: "Mensual" },
    { label: "Semestral", value: "Semestral" },
    { label: "Anual", value: "Anual" }
];

export const categoryNews = [
    { label: "Nacional", value: "nacional" },
    { label: "Internacional", value: "internacional" },
    { label: "De la Industria", value: "de_la_industria" },
    { label: "Eventos", value: "eventos" },
    { label: "Otros", value: "otros" }
];

export const categoryServices = [
    { label: "Desarrollo de Software", value: "desarrollo_de_software" },
    { label: "Consultoría", value: "consultoria" },
    { label: "Capacitación", value: "capacitacion" },
    { label: "Mantenimiento", value: "mantenimiento" },
    { label: "Otros", value: "otros" }
];

export const statusCompanies = [
    { label: "Activo", value: "Active" },
    { label: "Inactivo", value: "Inactive" },
];

export const companySizes = [
    { label: "0-2.400 UF Anuales", value: "Micro" },
    { label: "2.400,01 UF - 25.000 UF", value: "Small" },
    { label: "25.000,01 UF - 100.000 UF", value: "Medium" },
    { label: "100.000 UF y más", value: "Big" }
];

export const workersRanges = [
    {label: "0-9 Trabajadores", value: "0-9"},
    { label: "10-25 trabajadores", value: "10-25" },
    { label: "25-200 trabajadores", value: "25-200" },
    { label: "200 y más trabajadores", value: "200+" },

];